$(document).ready(function(){
  $(window).scroll(function(){
    var targetOffset = $("#animate_logo").offset().top;
    var theta = document.documentElement.scrollTop / 433 % Math.PI;
  //$("#animate_logo").css("transform","rotate("+ theta +"rad)");
    var targetOffset2 = $("#animate_logo2").offset().top;
    var theta2 = document.documentElement.scrollTop / 433 % Math.PI;
    //  $("#animate_logo2").css("transform","rotate("+ theta2 +"rad)");
  });

   $('#colorcollectionslidermain').slick({
        dots: false,
        infinite: true,
        speed: 500,
        centerMode: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        centerPadding: '0px',
        autoplaySpeed: 2000,
        arrows: false,
        dots:false,
        asNavFor:'.btncolorList',
        responsive: [{
          breakpoint: 769,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
           breakpoint: 480,
           settings: {
              slidesToShow: 1,
              slidesToScroll: 1
           }
        }]
    });

  $('.btncolorList').slick({
      slidesToShow: 7,
      asNavFor: '#colorcollectionslidermain',
      dots: false,
      arrows:true,
      centerPadding: '10px',  //decrease the padding to hide the next slide text
      centerMode: true,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 1100,
          settings: {
            slidesToShow: 5,
            centerPadding: '10px'
          }
        },
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 5,
            centerPadding: '10px'
          }
        },
        {
           breakpoint: 480,
           settings: {
             centerPadding: '10px',
              slidesToShow: 3
           }
        }]
    });

// On before slide change
$('.btncolorList').on('beforeChange', function(event, { slideCount: count }, currentSlide, nextSlide){
  let selectors = [nextSlide, nextSlide - count, nextSlide + count].map(n => `[data-slick-index="${n}"]`).join(', ');
  $('.slick-now').removeClass('slick-now');
  $(selectors).addClass('slick-now');
  var cLabel = $(".slick-now").find(".colorlabel").data("mcid");
  var URL = $('a[data-cid="'+cLabel+'"]').attr("href");
  var cTxt = $('a[data-cid="'+cLabel+'"]').text();
  $("#mainShopBtn").attr("href",URL);
   $("#mainShopBtn").css("background-color","#"+cLabel);
});

$('.btncolorList').find('.slick-active').addClass('slick-now');

  
});

$(window).on('scroll resize',createLine);
function createLine(){
 var $i = $('#vline');
  var $window = $(window);
  var offset = 0;
  var minHeight = 10;
  var scrollPercentage = 100 * $window.scrollTop() / ($('html').height() - $window.height());
  var maxHeight = $(window).height() - (offset * 2) - minHeight;
  var newHeight = ((maxHeight / 100) * scrollPercentage) + minHeight;
  $i.css('height', newHeight);
  
  if ($(window).width() > 990) {
    if($('.topGallerySlider')){
      if($('.topGallerySlider').length > 0){
        parallax0();
      }
    }
    if($('.parallaxPBG1')){
      if($('.parallaxPBG1').length > 0){
        var triggerAtY = $('.parallax--bg1').offset().top - $(window).outerHeight();
        if (triggerAtY > $(window).scrollTop()) {
        return;
        }
        //parallax1();
        //parallaxLace1();
      }
    }
  }
  if ($(window).width() <= 990) {
    if($('.topGallerySlider')){
      if($('.topGallerySlider').length > 0){
        parallaxMobile0();
      }
    }
    if($('.parallaxPBG1')){
      if($('.parallaxPBG1').length > 0){
        var triggerAtY = $('.parallax--bg1').offset().top - $(window).outerHeight();
        if (triggerAtY > $(window).scrollTop()) {
        return;
        }
        //parallaxMobile1();
      }
    }
  }
}

function parallax0(){
    var scrolled = $(window).scrollTop();
    var initY = $('.topGallerySlider').offset().top;
    var oheight = $('.topGallerySlider').height();
    var initY2 = initY + oheight;
    var flag2 = true;
    var flag1 = true; 
    if (scrolled < initY || scrolled > initY2) {
      if(flag2){
         if($('.topGallerySlider').find('.img-1').hasClass("marginTop165"))$('.topGallerySlider').find('.img-1').removeClass('marginTop165');
         if($('.topGallerySlider').find('.img-3').hasClass("marginTop145"))$('.topGallerySlider').find('.img-3').removeClass('marginTop145');
         if($('.topGallerySlider').find('.img-4').hasClass("marginTop315"))$('.topGallerySlider').find('.img-4').removeClass('marginTop315');
         flag2 = false;
      }
      return;
  }
    
    if(flag1){
      $('.topGallerySlider').find('.img-1').addClass('marginTop165');
      $('.topGallerySlider').find('.img-3').addClass('marginTop145');
      $('.topGallerySlider').find('.img-4').addClass('marginTop315');
      flag1 = false;
    }
}
function parallaxMobile0(){
    var scrolled = $(window).scrollTop();
    var initY = ($('.topGallerySlider').offset().top) / 2;
    var oheight = $('.topGallerySlider').height();
    var initY2 = initY + oheight;
    var flag2 = true;
    var flag1 = true; 
    if (scrolled < initY || scrolled > initY2) {
      if(flag2){
        if($('.topGallerySlider').find('.img-3').hasClass("marginTop60"))$('.topGallerySlider').find('.img-3').removeClass('marginTop60');
         flag2 = false;
      }
      return;
  }
    
    if(flag1){
      $('.topGallerySlider').find('.img-3').addClass('marginTop60');
      flag1 = false;
    }
}
function parallax1(){
  var scrolled = $(window).scrollTop();
  var initY = $('.parallaxPBG1').offset().top;
  var oheight = $('.parallaxPBG1').height();
  var endY  = initY + $('.parallax--bg1').oheight;
  var pbgLoc = scrolled - initY;
  var triggerAtY = $('.parallax--bg1').offset().top - $(window).outerHeight();
  var iH = initY + oheight;
  var oH = scrolled + oheight;
  var bottom = $(window).height() - oheight;
  var initY2 = initY + oheight;
  
  if (scrolled < initY || scrolled > initY2) {
    return;
  }
  var diff = scrolled - initY;
  var ratio = Math.round((diff / oheight) * 100);
  $('.parallax--bg1').css('background-position','center ' + ratio + 'px');

}

function parallaxLace1(){
  var scrolled = $(window).scrollTop();
  var height = $('.parallaxPBG1').height();
  
  var laceheight = $('.parallax--bg-lace1').height();
  var prevDivId = $('.parallaxPBG1').prev(".shopify-section").attr("id");
  var prevHeight = ($('#'+prevDivId).height()) / 2;
  var initY = ($('#'+prevDivId).offset().top) + prevHeight;
  
  
  $('.parallax--bg-lace1').css('height',height + 'px');
  var initLY = $('.parallaxPBG1').offset().top;
  var initLY2 = initLY;
  var endLY  = initY + $('.parallax--bg-lace1').height();
  var iH = initLY + laceheight;
  var oH = scrolled + laceheight;
  var bottom = $(window).height() - height;
  var initY2 = initLY + height;
  if (scrolled < initLY2 || scrolled > initY2) {
    return;
  }
  var diff = scrolled - initLY2;
  var ratio = Math.round(diff);
  var ratio2 = ratio * 2;
  if(ratio2 < (height - 60) && ratio2 <= 800){
    $('.parallax--bg-lace1').css('background-position','center ' + (ratio * 2)+ 'px');
  }
}

function parallaxMobile1(){
  var scrolled = $(window).scrollTop();
    var initY = $('.parallaxPBG1').offset().top;
    var oheight = $('.parallaxPBG1').height();
    var initY2 = initY + oheight;
    var flag2 = true;
    var flag1 = true; 
    if (scrolled < initY || scrolled > initY2) {
      if(flag2){
         if($('.parallaxPBG1').find('.custom-content').hasClass("marginTop501"))$('.parallaxPBG1').find('.custom-content').removeClass('marginTop501');
         flag2 = false;
      }
      return;
  }
    
    if(flag1){
      $('.parallaxPBG1').find('.custom-content').addClass('marginTop501');
      flag1 = false;
    }
}
